module.exports = __webpack_public_path__ + "static/media/comment-plus.b5c76a9b.svg";